var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-emphasized-select',{attrs:{"items":_vm.items,"aria-required":true,"label":_vm.label,"clearable":false,"disabled":_vm.disabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }